import React, { Dispatch, SetStateAction, useState } from 'react'

import { Button, Col, Form, PageHeader, Row } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import ID_COMPONENTE from 'config/idComponente'
import { ICandidato } from 'Models/docas'
import { useSnackbar } from 'react-simple-snackbar'
import WsDocasService from 'Services/WS_DOCAS'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'

interface IProps {
  id?: number
  nome?: string
  candidatos?: ICandidato[]
  setCandidatos: Dispatch<SetStateAction<ICandidato[] | undefined>>
  setModal: Dispatch<SetStateAction<boolean>>
}

const ModalRemocaoCandidato = ({
  id,
  nome,
  candidatos,
  setCandidatos,
  setModal,
}: IProps) => {
  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)

  const removeCandidato = async (justificativa: string) => {
    if (id) {
      setCandidatos(candidatos?.filter((f) => f.cdCandidatoAgendamento !== id))
      const { data } = await WsDocasService.candidatos.delete(
        ID_COMPONENTE.DOCAS,
        id,
        justificativa,
      )

      if (data?.statusCode === 200 || data?.statusCode === 501) {
        openSnackbarSuccess('Candidato removido com sucesso')
        setModal(false)
      }
    }
  }

  return (
    <Form onFinish={removeCandidato} layout="vertical">
      <PageHeader
        ghost={false}
        title={'Remover candidato: ' + nome}
        extra={[
          <Button key="removeCandidato" type="primary" htmlType="submit" danger>
            Remover
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="justificativa"
              label="Justificativa:"
              rules={[
                {
                  required: true,
                  message:
                    'É necessário informar uma justificativa para remover o candidato',
                },
              ]}
            >
              <TextArea rows={22} />
            </Form.Item>
          </Col>
        </Row>
      </PageHeader>
    </Form>
  )
}

export default ModalRemocaoCandidato
